import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SprintService } from 'app/api/services/sprint.service';
import { CollaborationInfo } from 'app/state/sprint.repository';
import { Tenant } from 'app/state/tenants.repository';
import { TenantsService } from 'app/state/tenants.service';
import { TrackRender } from 'app/shared/front-perfomance';

@TrackRender()
@Component({
  selector: 'app-tenant-info-page',
  templateUrl: './tenant-info-page.component.html',
  styleUrls: ['./tenant-info-page.component.scss'],
})
export class TenantInfoPageComponent {
  id: string | null = null;
  collabs: CollaborationInfo[] | null = null;
  tenant: Tenant | null = null;

  constructor(
    private route: ActivatedRoute,
    public service: SprintService,
    public tenatService: TenantsService
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe({
      next: (value) => {
        this.id = value.get('id')!;
        if (this.id) {
          this.service.loadInfo(this.id).subscribe((x) => {
            this.collabs = x;
          });
          this.tenatService.loadOneWithoutTrack(this.id).subscribe((x) => {
            this.tenant = x;
          });
        }
      },
    });
  }
}
